<template>
  <export-device-dialog class="exportPlantNew" :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }"
    :visible.sync="dialogVisible" :width="'600px'" :title="$t('report.Export_report')" noFooter>
    <div slot="content" class="grid" style="padding:0px;">
      <span class="label">
        {{ $t('report.Report_type') }}
      </span>
      <el-radio-group v-model="activeType" v-removeAriaHidden>
        <el-radio label="day">{{ $t('report.Daily_report') }}</el-radio>
        <el-radio label="range">{{ $t('report.customize') }}</el-radio>
      </el-radio-group>
      <span class="label">
        {{ $t('report.Report_date') }}
      </span>
      <el-date-picker :editable='false' ref="dayDeviceDataRef" :clearable="false" v-model="datevalue"
        v-show="activeType === 'day'" type="date" :placeholder="$t('report.select_date')" popper-class="select-date"
        :picker-options="pickerDayOptions" @blur="handleClickShow()">
      </el-date-picker>
      <el-date-picker :editable='false' :clearable="false" v-model="datevalue" v-show="activeType === 'range'"
        type="daterange" align="left" unlink-panels ref="rangeDeviceDataRef" :range-separator="$t('report.to')"
        :picker-options="pickerrangeOptions" :start-placeholder="$t('report.start_date')"
        :end-placeholder="$t('report.End_date')" :default-value="new Date().setMonth(new Date().getMonth() - 1)"
        style="width:100%;positon:relative;" popper-class="select-date1">
      </el-date-picker>
      <span></span>
      <div style="width:100%;text-align:right;">
        <el-button class="btn-dark" style="padding: 10px 12px;border-radius: 6px;" @click="exportDeviceData"
          :disabled="exportDeviceValue">{{ $t('report.Export') }}</el-button>
      </div>
    </div>
    <div slot="footer">
    </div>
  </export-device-dialog>
</template>
<script>
import exportDeviceDialog from "@/components/dialognew/index";
import { i18n } from '@/i18n';
export default {
  components: {
    exportDeviceDialog
  },
  props: {
    params: {
      default: null
    }
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.closeDialog();
        this.$refs.dayDeviceDataRef.handleClose()
        this.$refs.rangeDeviceDataRef.handleClose()
        document.removeEventListener('click', this.handleDocumentClick, true);
      } else {
        this.activeType = "day"
        this.datevalue = new Date();
        document.addEventListener('click', this.handleDocumentClick, true);
      }
    },
    params(val) {
      this.dialogVisible = !!val;
    },
    activeType(val) {
      this.$refs.dayDeviceDataRef.handleClose()
      this.$refs.rangeDeviceDataRef.handleClose()
      if (val) {
        if (val == 'day') {
          this.datevalue = new Date();
        }
      }
    },
  },
  data() {
    return {
      exportDeviceValue: false,
      dialogVisible: false,
      datevalue: new Date(),
      activeType: "day",
      pickerDayOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate(time) {
          return time.getTime() >= new Date();
        }
      },
      //自定义日期选择限定31天
      startDate: '',
      pickerrangeOptions: {
        //时间范围选择控制
        onPick: ({ maxDate, minDate }) => {
          this.startDate = minDate && minDate.getTime()
          if (maxDate) {
            // 选中后一个时，要把第一个的赋值清空
            this.startDate = ''
          }
        },
        disabledDate: time => {
          // 选中第一个后，后一个前后31天可选，超出的不可选，超出当前天也不可选，这里的天数按需求设定
          const minTime = new Date(this.startDate).setDate(
            new Date(this.startDate).getDate() - 30
          )
          const maxTime = new Date(this.startDate).setDate(
            new Date(this.startDate).getDate() + 30
          )
          return (
            time.getTime() > Date.now() ||
            (this.startDate
              ? time.getTime() < minTime || time.getTime() > maxTime
              : false)
          )
        },
      },
    };
  },
  methods: {
    handleDocumentClick(event) {
      if (!this.$refs.dayDeviceDataRef.$el.contains(event.target) && this.activeType == 'day' && event.target.closest('.select-date') == null) {
        // 手动关闭日期选择器和对话框
        this.$refs.dayDeviceDataRef.handleClose()
      } else if (!this.$refs.rangeDeviceDataRef.$el.contains(event.target) && this.activeType == 'range' && event.target.closest('.select-date1') == null) {
        this.$refs.rangeDeviceDataRef.handleClose()
      }
    },
    handleClickShow() {
      this.$refs.dayDeviceDataRef.blur()
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit("update:params", null);
    },
    //导出报表
    exportDeviceData() {
      if (this.activeType == 'range' && this.datevalue.length != 2) {
        return false
      }
      // 判断接口与导出接口入参一致，公用一份param(与newhistoricalViewTable的loadExcel对齐，不传i18n)
      let param = {
        date: this.activeType == 'day' ? this.$filter.formatDate(this.datevalue, "yyyy-MM-dd") : this.$filter.formatDate(this.datevalue[0], "yyyy-MM-dd"),
        endDate: this.activeType == 'day' ? this.$filter.formatDate(this.datevalue, "yyyy-MM-dd") : this.$filter.formatDate(this.datevalue[1], "yyyy-MM-dd"),
        devaddr: this.params.devaddr,
        devcode: this.params.devcode,
        pn: this.params.pn,
        sn: this.params.sn,
        webHeads: this.params.webHeads || []
      };
      this.exportDeviceValue = true
      // 查询导出数据是否超出限制
      this.$request.postDEVMicroservices("/drt/api/auth/web/getDeviceDatSize", param)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t("report.download"));
            // 导出接口(微服务，入参与判断接口相同，返回文件流)
            this.$request.postDEVMicroservices("/drt/api/auth/web/exportDeviceDat", param)
              .then((ress) => {
                // 拦截器对带content-disposition的响应会返回完整AxiosResponse对象，取其data才是文件流
                const fileData = ress instanceof Blob ? ress : ress.data;
                // 后端错误时返回JSON，其余(含octet-stream/ms-excel等)均视为文件流直接下载
                if (fileData && fileData.type && fileData.type !== "application/vnd.ms-excel") {
                  // 非文件流：解析后端返回的错误信息
                  const blob = new Blob([fileData])
                  blob.text().then(result => {
                    try {
                      const json = JSON.parse(result)
                      this.$message.error(json.message || json.errorMessage)
                    } catch (e) {
                      this.$message.error(i18n.t("report.Export_report") + i18n.t("errCode.1"))
                    }
                  })
                } else {
                  // this.$message.success(this.$t("report.download"));
                  const xlsx = "application/vnd.ms-excel";
                  const blob = new Blob([fileData], { type: xlsx });
                  const a = document.createElement("a"); // 转换完成，创建一个a标签用于下载
                  a.download = this.activeType == 'day'
                    ? param.pn + '(' + param.date + ').xlsx'
                    : param.pn + '(' + param.date + '-' + param.endDate + ').xlsx';
                  a.href = window.URL.createObjectURL(blob);
                  a.click();
                  a.remove();
                  this.closeDialog();
                }
                this.exportDeviceValue = false
              }).catch(() => {
                this.exportDeviceValue = false
              });
          } else {
            this.$message.error(res.message || res.errorMessage);
            this.exportDeviceValue = false
          }
        }).catch(() => {
            this.exportDeviceValue = false
        });
    }
  }
};
</script>
<style lang="less" scoped>
.exportPlantNew {
  .label {
    font-size: 14px;
    color: rgb(242, 242, 242);
    margin-right: 20px;
  }

  .el-input__icon {
    line-height: 32px
  }

  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-separator {
    color: #fff;
  }

  /deep/.el-radio__input.is-checked .el-radio__inner {
    border-color: rgb(51, 255, 182);
    background: @primaryTextColor;
  }

  /deep/.el-radio__input.is-checked+.el-radio__label {
    color: rgb(242, 242, 242);
  }

  /deep/.el-radio {
    color: rgb(242, 242, 242);
  }

  /deep/.el-date-editor .el-input__icon {
    color: rgb(56, 165, 118);
  }

  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 7px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }
}
</style>
<style lang="less">
// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}

.select-date1.el-picker-panel {
  background-color: #222D35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222D35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }


  .in-range {
    background-color: #222D35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  .el-date-table td.in-range {
    background-color: #222D35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff
  }
}

.el-date-table td.disabled div {
  background-color: #222D35 !important;
  color: #606266 !important;
}

.el-year-table td.disabled .cell {
  background-color: #222D35 !important;
}

.el-month-table td.disabled .cell {
  background-color: #222D35 !important;
}
</style>